import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import generateI18nData from "./translationData.js";

let resources = {};

resources = {
  en: { translation: generateI18nData("English") },
  fr: { translation: generateI18nData("French") },
  de: { translation: generateI18nData("German") },
  es: { translation: generateI18nData("Spanish") },
  it: { translation: generateI18nData("Italian") },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    resources,
  });

export default i18n;
